// Data para los combustibles disponibles con poderes caloríficos, factores de emisión y densidades
export const combustibles = [
  { 
    // Gasolina E10 (Comercial)
    id: 'gasolina', 
    nombre: 'Gasolina', 
    unidad: 'galones',
    poderCalorifico: 41.95665, // MJ/kg
    densidad: 0.75, // kg/L (densidad típica gasolina E10)
    factorEmision: 7.6181, // kg CO2 por galón
    litrosPorGalon: 3.785, // L/gal
  },
  { 
    // Diesel B2
    id: 'diesel', 
    nombre: 'Diésel', 
    unidad: 'galones',
    poderCalorifico: 43.847, // MJ/kg
    densidad: 0.8519, // kg/L (densidad típica diesel B2)
    factorEmision: 10.149, // kg CO2 por galón
    litrosPorGalon: 3.785, // L/gal
  },
  { 
    // GLP Genérico
    id: 'glp', 
    nombre: 'GLP (Gas Licuado de Petróleo)', 
    unidad: 'kilos',
    poderCalorifico: 47.240, // MJ/kg
    densidad: 0.54, // kg/L (densidad típica GLP líquido)
    factorEmision: 3.0512, // kg CO2 por kg de GLP
  },
  { 
    // Carbón Genérico
    id: 'carbon', 
    nombre: 'Carbón', 
    unidad: 'toneladas',
    poderCalorifico: 29.393, // MJ/kg
    densidad: 1.4, // kg/L (densidad aparente del carbón)
    factorEmision: 2534.814, // kg CO2 por tonelada
    kgPorTonelada: 1000, // kg/ton
  }
];

// Datos del gas natural
export const gasNatural = {
  poderCalorifico: 42.441895, // MJ/m³
  factorEmision: 2.1908, // kg CO2 por m³
};